import { assertNever } from "@glideapps/ts-necessities";
import * as t from "io-ts";
import { AddonKind } from "./billing-vnext/subscriptions";

export enum BoostCode {
    FiveHundredRows = "boost-rows-500",
    OneKiloRows = "boost-rows-1000",
    TwoKiloFiveRows = "boost-rows-2500",
    FiveKiloRows = "boost-rows-5000",
    OneKiloReads = "boost-reads-1000",
}

// FIXME: Is this the best way to do this?
export const boostCodeCodec = t.union([
    t.literal(BoostCode.FiveHundredRows),
    t.literal(BoostCode.OneKiloRows),
    t.literal(BoostCode.TwoKiloFiveRows),
    t.literal(BoostCode.FiveKiloRows),
    t.literal(BoostCode.OneKiloReads),
]);

export function boostCodeToAddonKind(code: BoostCode): AddonKind {
    switch (code) {
        case BoostCode.FiveHundredRows:
            return AddonKind.V2Boost500Rows;
        case BoostCode.OneKiloRows:
            return AddonKind.V2Boost1000Rows;
        case BoostCode.TwoKiloFiveRows:
            return AddonKind.V2Boost2500Rows;
        case BoostCode.FiveKiloRows:
            return AddonKind.V2Boost5000Rows;
        case BoostCode.OneKiloReads:
            return AddonKind.V2Boost1000Reads;
        default:
            assertNever(code, "Boost code not handled!");
    }
}
export function AddonKindToBoostCode(code: AddonKind): BoostCode | undefined {
    switch (code) {
        case AddonKind.V2Boost500Rows:
            return BoostCode.FiveHundredRows;
        case AddonKind.V2Boost1000Rows:
            return BoostCode.OneKiloRows;
        case AddonKind.V2Boost2500Rows:
            return BoostCode.TwoKiloFiveRows;
        case AddonKind.V2Boost5000Rows:
            return BoostCode.FiveKiloRows;
        case AddonKind.V2Boost1000Reads:
            return BoostCode.OneKiloReads;
        default:
            return undefined;
    }
}
